/**
 * Registry profile/photo URLs from Crimeometer may contain HTML entities (e.g. &amp;).
 * Backend normalizes on ingest; this guards the UI for any already-cached responses.
 */
export function normalizeRegistryUrl(url: string): string {
  return url.replaceAll("&amp;", "&");
}
